import useCurrentUser from "data/advisor/useCurrentUser";

import { useFeatures } from "components/FeatureFlag";

// A stored work-desk preference wins while the experiment flag is on;
// otherwise the legacy work-desk-beta flag decides (flag off = kill switch,
// preference ignored). useFeatures returns false while loading or missing.
export function useWorkDeskEnabled() {
  const workDeskToggle = useFeatures("work-desk-toggle-switch");
  const workDeskBeta = useFeatures("work-desk-beta");
  const workDeskPreference = useCurrentUser()?.preferences?.["work-desk"];

  if (workDeskToggle?.enabled && typeof workDeskPreference === "boolean") {
    return workDeskPreference;
  }

  return Boolean(workDeskBeta);
}

export default useWorkDeskEnabled;
